var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtbg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 246,
    viewBox: "0 0 207 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5026_5342)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    width: 205.256,
    height: 246,
    rx: 14.2668,
    fill: "#D5E7FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.7695,
    cy: 223,
    r: 55,
    fill: "url(#paint0_linear_5026_5342)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7695,
    cy: 37,
    r: 31,
    fill: "url(#paint1_linear_5026_5342)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.77,
    cy: 178,
    r: 45,
    fill: "url(#paint2_linear_5026_5342)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5026_5342",
    x1: 31.7695,
    y1: 168,
    x2: 31.7695,
    y2: 278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87C2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5026_5342",
    x1: 38.7695,
    y1: 6,
    x2: 38.7695,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87C2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EFFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5026_5342",
    x1: 174.77,
    y1: 133,
    x2: 174.77,
    y2: 223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87C2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1EFFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5026_5342"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.769531,
    width: 205.256,
    height: 246,
    rx: 14.27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtbg4);
export default __webpack_public_path__ + "static/media/ctbg4.b69b69e27414df20575efa7de9d80fb6.svg";
export { ForwardRef as ReactComponent };